
import CustomerPayment from '@/views/CustomerPayment/CustomerPayment.vue'
export default [
    {
        path: '/customer_payment',
        name: 'customerPayment',
        component: CustomerPayment,
    }
]